import React, { Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import { InputTextField } from "js/components/Shared/Form/Fields";
import { isValidUrl, isValidUrlOrEmpty } from "js/helpers/validations";

const Trivia = ({ disabled }) => {
  return (
    <Fragment>
      <Grid item xs={12}>
        <InputTextField
          name="trivia.urlEdicion"
          validate={isValidUrl}
          label="URL para la edición"
          disabled={disabled}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <InputTextField
          name="trivia.url"
          validate={isValidUrl}
          label="URL de la trivia"
          disabled={disabled}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <InputTextField
          name="trivia.urlReporte"
          validate={isValidUrlOrEmpty}
          label="URL del reporte"
          disabled={disabled}
        />
      </Grid>
    </Fragment>
  );
};

Trivia.displayName = "TRIVIA";

export default Trivia;
